export const setCurrentTab = tab => ({
  type: 'SET_CURRENT_TAB',
  tab,
});
